//import Vue from 'vue'
import { createApp } from "vue";
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css'
import Notifications from "@kyvg/vue3-notification";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faVolumeHigh, faVolumeXmark, faArrowsRotate, faToiletPaper, faScroll, faPrint, faComment, faRunning, faCoffee, faHamburger, faSmileWink, faStar, faHeart, faSmileBeam, faFingerprint,faCheckCircle, faSignOutAlt, faPhone, faEnvelope, faWrench, faTimes, faPersonRunning, faDesktop} from '@fortawesome/free-solid-svg-icons'
import { faMinusSquare } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//Vue.component('font-awesome-icon', FontAwesomeIcon)


library.add(faVolumeHigh, faVolumeXmark, faArrowsRotate, faToiletPaper, faScroll, faPrint, faRunning, faCheckCircle, faFingerprint, faSmileWink, faSmileBeam, faHeart, faStar, faSignOutAlt, faHamburger, faCoffee, faMinusSquare, faComment, faPhone, faEnvelope, faWrench, faTimes, faPersonRunning, faDesktop)

//Vue.config.productionTip = false

const app = createApp(App);

/***new Vue({
  render: h => h(App),
  }).$mount('#app')***/
app.use(Notifications).component("font-awesome-icon", FontAwesomeIcon).mount("#app");